import React from "react";

const ActionMenuItem = ({
    icon,
    label,
    danger,
    activeRed,
    onClick,
    withDivider,
    disabled,
    title,
}) => (
    <>
        <button
            type="button"
            onClick={disabled ? undefined : onClick}
            title={title}
            className={`tw-w-full tw-flex tw-items-center tw-gap-3 tw-text-left tw-px-5 tw-py-3 hover:tw-bg-gray-50 ${
                danger || activeRed ? "tw-text-red-600" : "tw-text-gray-800"
            } ${disabled ? "tw-opacity-50 tw-cursor-not-allowed" : ""}`}
            disabled={disabled}
        >
            <span
                className={`tw-flex tw-items-center ${
                    danger ? "tw-text-red-500" : "tw-text-gray-700"
                }`}
            >
                {/* Callers pass either an element or a Font Awesome class ("fa-ban");
                    a bare string used to render as text. */}
                {typeof icon === "string" ? (
                    <i className={`fa ${icon} tw-w-4 tw-text-center`} aria-hidden="true" />
                ) : (
                    icon
                )}
            </span>
            <span className="tw-text-[15px]">{label}</span>
            {activeRed && (
                <span className="tw-ml-auto tw-text-gray-400">
                    <i className="fas fa-check" />
                </span>
            )}
        </button>
        {withDivider && <div className="tw-border-t tw-border-gray-200" />}
    </>
);

const ActionMenu = React.forwardRef(({ children, className = "", style = {} }, ref) => (
    <div
        ref={ref}
        className={`tw-bg-white tw-rounded-2xl tw-shadow-2xl tw-border tw-border-gray-100 tw-w-80 ${className}`}
        style={style}
    >
        {children}
    </div>
));

ActionMenu.Item = ActionMenuItem;

export default ActionMenu;
